import React, { FC, useState } from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import { SanityMenuLink } from 'web/types/graphql-types'
import TextField from '@/components/TextField'
import Box from '@/atoms/Box'
import Link from '@/atoms/Link'
import Text from '@/atoms/Text'

const Footer: FC = () => {

  const { data } = useStaticQuery(graphql`
    query {
      data: sanitySiteSettingsNavigation {
        desktopSecondary {
          label
          link {
            ...Link
          }
        }
      }
    }
  `)

  const desktopSecondary: SanityMenuLink[] = data.desktopSecondary
  const [email, setEmail] = useState('')
  return (
    <Box
      height="12rem"
      display={['none', 'flex']}
      flexDirection="row"
      justifyContent="flex-end"
      position="fixed"
      bottom={0}
      left={0}
      width="100%"
    >
      <Box mx={5} display="flex" flexDirection="row" justifyContent="space-between" alignItems="center" width="100%">
        <div id="mc_embed_signup">
          <form action="https://arys-berlin.us12.list-manage.com/subscribe/post?u=a8a5761d1fa5c1c18d56df31a&amp;id=7061eb21a5" method="post" id="mc-embedded-subscribe-form-desktop" name="mc-embedded-subscribe-form" className="validate" target="_blank" noValidate>
            <div id="mc_embed_signup_scroll">
              <Box width="400px" display="flex" flexDirection="row">
                <TextField
                  type="email"
                  name="EMAIL"
                  id="mce-EMAIL"
                  width="256px"
                  height="34px"
                  label="enter e-mail for mailing list"
                  value={email}
                  setValue={setEmail}
                  autocomplete="email"
                  variant="desktop"
                />
              { email &&
                <Box display="flex" justifyContent="flex-end">
                  <Text
                    textAlign="right"
                    pt={['10px', '8px', '4px']}
                    pr={2}
                    ml={2}
                    color="white"
                    variant="captionSmall"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      document.getElementById('mc-embedded-subscribe-form-desktop')?.submit()
                    }}
                  >
                    send
                  </Text>
                </Box>}
              </Box>
              <div id="mce-responses" className="clear">
                <div className="response" id="mce-error-response" style={{ display: 'none' }}></div>
                <div className="response" id="mce-success-response" style={{ display: 'none' }}></div>
              </div>
              <div style={{ position: 'absolute', left: '-5000px' }} aria-hidden="true"><input type="text" name="b_a8a5761d1fa5c1c18d56df31a_7061eb21a5" tabIndex={-1} value="" /></div>
            </div>
          </form>
        </div>
        <Box display="flex" flexDirection="row" justifyContent="flex-end" alignItems="center">
          {desktopSecondary.map(({ label, link }) =>
            <Link {...link}>
              <Text color="white" pl={2} variant="captionSmall">
                {label}
              </Text>
            </Link>
          )}
        </Box>
      </Box>
    </Box>
  )
}

export default Footer
